import React from 'react';

import View from './view';
import {NotificationResponsePayload} from '../../../../shared/models/api';

interface Props {
  notifications: NotificationResponsePayload[] | null;
  hideBottomLineWhenAllShown?: boolean;
}

export const Notifications = ({notifications, hideBottomLineWhenAllShown}: Props) => {
  return (
    <View
      count={notifications?.length}
      notifications={notifications?.slice(0, 3)}
      hideBottomLineWhenAllShown={hideBottomLineWhenAllShown}
    />
  );
};
